import { gql } from '@efficiently/client-core-graphql-models';

export const UPLOAD_CONTENTS = gql(`
	mutation UploadContents($args: ContentUploadArgs!) {
		uploadContents(args: $args) {
			...ContentDomainContentFields
		}
	}
`);
